import { render, staticRenderFns } from "./PemdaTransactionContent.vue?vue&type=template&id=796f0bed&lang=pug"
import script from "./PemdaTransactionContent.vue?vue&type=script&lang=js"
export * from "./PemdaTransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports